<template>
  <div style="background: #ffffff;padding: 24px;">
    <div style="display: flex;justify-content: space-between;">
      <a-form
        v-bind="formItemLayout"
        ref="formRef"
        style="width: 100%;flex: 1;"
        :model="formState"
        @finish="handleQuery"
      >
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item
              label="版本号"
              :label-col="{ styles: { width: '100px' } }"
              name="version"
            >
              <a-input v-model:value="formState.version" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-button htmlType="submit" type="primary">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
      <a-button type="primary" @click="handleRelease">版本发布</a-button>
    </div>
    <a-tabs v-model:activeKey="activeKey" @change="handleTabChange">
      <a-tab-pane key="1" tab="Web版本管理" />
      <a-tab-pane key="2" tab="APP版本管理" />
    </a-tabs>
    <a-row :gutter="16">
      <List />
    </a-row>
  </div>
</template>
<script>
import { toRefs, provide, onMounted } from 'vue'
import List from './components/List'
import { useRelease } from './release'

export default {
  name: 'StaticLangRelease',
  components: {
    List
  },
  setup() {
    const state = useRelease()

    onMounted(() => state.initList())
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
